import { ng } from '@uirouter/angularjs/lib/angular';
import angular = require('angular');
import { IPopupSettings } from '../../models';
import { PopupServiceCancel } from '../../models/popupServiceCancel';

class InfoPopup {
    public static $inject = ['$sce'];

    public title: string;
    public body: string;
    public resolve: {
        settings: IPopupSettings;
    };

    private modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;

    constructor(private $sce: ng.ISCEService) { }

    public $onInit() {
        const settings = this.resolve.settings;
        this.title = settings.title;
        this.body = this.$sce.trustAsHtml(settings.content);
    }

    public cancel() {
        this.modalInstance.dismiss({ $value: new PopupServiceCancel('cancel') });
    }
}

angular.module('app.common')
    .component('infoPopup', {
        template: require('./infoPopup.component.html'),
        controller: InfoPopup,
        controllerAs: 'ctrl',
        bindings: {
            resolve: '=',
            close: '&',
            dismiss: '&'
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/infoPopup/infoPopup.component.ts